<a
  class="name"
  routerLink="/search"
  [queryParams]="categoryId>0?{category_ids:categoryId}:{}"
  >{{title}}</a
>
<a
  class="more"
  routerLink="/search"
  [queryParams]="categoryId>0?{category_ids:categoryId}:{}"
  >View More</a
>
